import styled, { css } from 'styled-components';
import { useSettings } from '@wu/widget-core';
import ButtonContent from './ButtonContent';
import { FreeLink } from './FreeLink';

export function Main() {
  const { font, positionType } = useSettings();

  return (
    <Inner _font={font?.value}>
      <ButtonContent />
      {positionType === 'embedded' && <FreeLink />}
    </Inner>
  );
}

const Inner = styled.div`
  ${({ _font }) =>
    _font &&
    css`
      font-family: ${_font};
    `};
  display: block;
  box-sizing: border-box;
  min-width: 100px;
  width: 100%;
  position: relative;
`;
